import { createSelector } from 'reselect'
import { getAppName } from 'redux/app/selectors'

export const getCurrentMedia = state => state.currentMedia

export const getCurrentMediaRecord = createSelector(
    getCurrentMedia,
    currentMedia => currentMedia.record,
)

export const getCurrentMediaArkId = createSelector(
    getCurrentMediaRecord,
    record => record.arkId || undefined
)

export const getCurrentMediaArkName = createSelector(
    getCurrentMediaArkId,
    arkId => arkId.arkName || undefined,
)

export const getCurrentMediaRecordUrl = createSelector(
    getCurrentMediaRecord,
    record => record && record.url,
)

export const isCurrentMediaSourceLoaded = createSelector(
    getCurrentMedia,
    (state, viewId) => viewId,
    (currentMedia, viewId) => currentMedia.isSourceLoaded[viewId] === true
)

export const isCurrentMediaSourceLoadedInDefaultFrame = (state) => isCurrentMediaSourceLoaded(state, 'default')
export const isCurrentMediaSourceLoadedInPreviewFrame = (state) => isCurrentMediaSourceLoaded(state, 'preview')

export const getCurrentMediaTitle = createSelector(
    getCurrentMediaRecord,
    getAppName,
    (record, appName) => computeTitle(record, appName)
)

export const getCurrentMediaDescription = createSelector(
    getCurrentMediaRecord,
    mediaRecord => mediaRecord && mediaRecord.description
)

export const isCurrentMediaTypeImage = createSelector(
   getCurrentMedia,
   media => media.type === 'image'
)

export const isCurrentMediaViewable = createSelector(
    getCurrentMedia,
    media => media.isSupported && media.isAvailable
)

export const isDownloadMediaDisabled = createSelector(
    getCurrentMedia,
    media => ! media.isAvailable
)

export const getCurrentMediaRecordPeriod = createSelector(
    getCurrentMediaRecord,
    record => {
        if(! record.period)
        {
            return null
        }

        if(! record.period.boundaries)
        {
            return null
        }

        return record.period.boundaries
    }
)

export const getCurrentMediaRecordLocationKeywords = createSelector(
    getCurrentMediaRecord,
    record => {
        if(! record.locationKeywords || ! Array.isArray(record.locationKeywords))
        {
            return null
        }

        return record.locationKeywords
    }
)

export const getCurrentMediaIIIFLocation = createSelector(
    getCurrentMedia,
    currentMedia => currentMedia.location.iiif
)

function computeTitle(record, appName)
{
    if(record === undefined) return {}

    let title = {
        'recordTitle': null,
        'referenceCode': null,
        'appName': null,
    }

    if(Array.isArray(record.title))
    {
        title.recordTitle = record.title.join(', ')
    }

    if(Array.isArray(record.referenceCode))
    {
        title.referenceCode = record.referenceCode.join(', ')
    }

    if(appName !== undefined)
    {
        title.appName = appName
    }

    return title
}
